import React from "react";
import { Collapse } from "antd";
import { faqs } from "../../data/faqs";
import SectionTitle from "../SectionTitle/SectionTitle";

function FAQSection() {
  const items = faqs.map((item, index) => ({
    key: index,
    label: item.question,
    children: <p>{item.answer}</p>,
  }));

  return (
    <section className="section" id="faq">
      <div className="container">
        <SectionTitle
          center
          eyebrow="Dúvidas"
          title="Perguntas frequentes"
        />

        <Collapse items={items} />
      </div>
    </section>
  );
}

export default FAQSection;